export { default } from './LiveWindPaywall';
